import type { ReactNode } from 'react';
import { sv } from '@aldorock-fordon/shared/sv';

/** A table under its caption. Scrolls inside itself, never the page; optional columns hide on a phone. */
export function Table({
  caption,
  children,
  empty,
  isEmpty,
  hasOptional = false,
  id,
}: {
  caption: string;
  children: ReactNode;
  empty?: string;
  isEmpty?: boolean;
  hasOptional?: boolean;
  id?: string;
}) {
  if (isEmpty) {
    return (
      <section className="block" aria-labelledby={id}>
        <h2 className="block-title" id={id}>
          {caption}
        </h2>
        <p className="muted">{empty ?? sv.table.empty}</p>
      </section>
    );
  }
  return (
    <div className="block">
      <div
        className="table-wrap"
        tabIndex={0}
        role="region"
        aria-label={sv.table.scrollLabel(caption)}
      >
        <table className="table" id={id}>
          <caption>{caption}</caption>
          {children}
        </table>
      </div>
      {hasOptional ? <p className="caption phone-note">{sv.table.phoneNote}</p> : null}
    </div>
  );
}
